<div class="loader" *ngIf="loader.isLoading | async">
</div>
